import request from "@/utils/request";

// 创建党建引领
export const createDangj = (data) => {
    return request({
        url: "/businessservice/dangjian/create",
        method: "post",
        data: data
    })
}

// 创建党建引领
export const updateDangj = (data) => {
    return request({
        url: "/businessservice/dangjian/update",
        method: "post",
        data: data
    })
}

// 创建党建引领
export const pageDangj = (data) => {
    return request({
        url: "/businessservice/dangjian/page",
        method: "post",
        data: data
    })
}

// 查询党建引领信息
export const  infoDangj =(query) =>{
    return request({
        url: "/businessservice/dangjian/info",
        method:"get",
        params: query
    })
}

// 删除党建引领信息
export const  deleteDangj =(query) =>{
    return request({
        url: "/businessservice/dangjian/delete",
        method:"get",
        params: query
    })
}

// 置顶党建引领信息
export const  topDangj =(query) =>{
    return request({
        url: "/businessservice/dangjian/top",
        method:"get",
        params: query
    })
}

// 首页党建引领信息
export const  homeDangj =(query) =>{
    return request({
        url: "/businessservice/dangjian/home",
        method:"get",
        params: query
    })
}

// 首页党建引领信息（新）
export const  homeDangjNew =(query) =>{
    return request({
        url: "/businessservice/dangjian/homeNew",
        method:"get",
        params: query
    })
}